import React from 'react';
import Popper from '@material-ui/core/Popper';
import Modal from '@material-ui/core/Modal';
import { AnimatePresence } from "framer-motion"

import { Animation } from 'components'

const PopOut = (props) => {
    const {
        id,
        element,
        trigger,
        placement,
        point,
        animation,
        onOpen,
        onClose
    } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [open, openPopper] = React.useState(false)
    const [popped, setPopped] = React.useState(false)

    React.useEffect(() => {
        // document.body.style.overflow = open ? 'hidden' : 'auto'
        // document.body.style.paddingRight = open ? '8px' : '0px'

        open && window.addEventListener('wheel', preventScroll, { passive: false })
        open && window.addEventListener('keydown', onKeyDown)
        return () => {
            window.removeEventListener('wheel', preventScroll)
            window.removeEventListener('keydown', onKeyDown)
        }
    }, [open])

    const preventScroll = (e) => {
        const scrollableElements = e.path.filter(x => x.scrollHeight !== x.clientHeight)
        const scrollableTagNames = scrollableElements.map(x => x.tagName)
        if(scrollableTagNames[0] === 'HTML'){
            e.preventDefault();
            e.stopPropagation();
            return false;
        } else {
            return true
        }
    }

    const onKeyDown = (e) => {
        if([38,40].includes(e.keyCode)){
            e.preventDefault();
            return false
        } else {
            return true
        }
    }

    const clickHandler = (event) => {
        if(point && event){
            event.stopPropagation()
            event.preventDefault();
            event.persist();
            setAnchorEl(anchorEl ? null : {
                getBoundingClientRect: () => ({
                    top: event.clientY,
                    left: event.clientX,
                    bottom: event.clientY,
                    right: event.clientX,
                    width: 1,
                    height: 1,
                }),
                clientWidth: 1,
                clientHeight: 1
            });
        } else {
            setAnchorEl(anchorEl ? null : event.currentTarget);
        }

        // Callback functions
        onOpen && onOpen()
        open && onClose && onClose()

        // Set state
        openPopper(!open);
        setPopped(!popped)
    }

    const popOutElement = React.cloneElement(element, {closeHandler: clickHandler})
    const mainContent = 
    <div>
        <div onClick={trigger === 'leftClick' ? clickHandler : null} 
            onContextMenu={trigger === 'rightClick' ? clickHandler : null}
            onMouseEnter={(trigger === 'onHover' & !open) ? clickHandler : () => {}}>
            {props.children}
        </div>

        <AnimatePresence>
            {open && 
            <Modal onBackdropClick={clickHandler} onEscapeKeyDown={clickHandler} open={open} BackdropProps={{invisible:true}} disableScrollLock id='MODAL'>
                {/* zIndex was 1301 previously */}
                <Popper style={{zIndex: 1300, outline:'none'}} id='PopOut' open={open} anchorEl={anchorEl} placement={placement || 'bottom-start'}>
                    <Animation animation={animation || 'default'} style={{zIndex: 9999}}>{popOutElement}</Animation>
                </Popper>
            </Modal>}
        </AnimatePresence>
    
    </div>

    return (
        <div style={{width:'100%'}}>{mainContent}</div>
    )
}

export default PopOut;
